<div class="nsc-page-title" *ngIf="content.pageTitle">
  <h2>{{ content.pageTitle }} </h2>
  <p   *ngIf="content.recipient"><strong>Send To:</strong> {{content.recipient}}</p>
  <nsc-spacer size="md"></nsc-spacer>
</div>